
import { uniqueId } from "lodash";
import { useEffect, useState } from "react";

// Styles
import styles from "./Pagination.module.scss";

const Pagination = ({ range, setPage, page, slice }) => {
  const [visibleRange, setVisibleRange] = useState<any>({ first: 1, last: 5 });

  useEffect(() => {
    if (slice.length < 1 && page !== 1) {
      setPage(page - 1);
    }
    if (page >= 3 && (page <= range.slice(-1)[0] - 2)) {
      setVisibleRange({ first: (page - 2), last: (page + 2) });
    }

  }, [slice, page, setPage]);

  function nextPage() {
    setPage(page + 1);
  }

  function previousPage() {
    setPage(page - 1);
  }

  function goToLastPage() {
    setPage(range.slice(-1)[0]);
    setVisibleRange({ first: (range.slice(-1)[0] - 4), last: range.slice(-1)[0] });
  }

  function goToFistPage() {
    setPage(1);
    setVisibleRange({ first: 1, last: 5 });
  }

  return (
    <div className={styles.pagination}>
      {range.length ? <button
        disabled={page === range[0]}
        className={`${styles.button} ${page === range[0] && styles.noClick}`}
        onClick={() => previousPage()}>
        <i className="fas fa-chevron-left"></i>
      </button> : null}
      {range.map((el, index) => {
        if (el < (visibleRange.first) && el === range[0]) {
          return <div key={uniqueId()}><button       
            className={`${styles.button} ${page === 1 ? styles.activeButton : styles.inactiveButton
              }`}
            onClick={() => goToFistPage()}>
            1
          </button><button
            className={styles.dotsButton}>
              {(page - 2) === range[0] ? null : "..."}
            </button>
          </div>
        }
        else if (el >= visibleRange.first && el <= visibleRange.last) {
          return <div key={uniqueId()}>
            <button
              className={`${styles.button} ${page === el ? styles.activeButton : styles.inactiveButton
                }`}
              onClick={() => setPage(el)}>
              {el}
            </button></div>
        }
        else {
          if (el === (range.slice(-1)[0])) {
            return <div key={uniqueId()}><button      
              className={styles.dotsButton}>
              {(page + 2) === range.slice(-1)[0] ? null : "..."}
            </button>
              <button
                className={`${styles.button} ${page === range.slice(-1)[0] ? styles.activeButton : styles.inactiveButton
                  }`}
                onClick={() => goToLastPage()}>
                {range.slice(-1)[0]}
              </button></div>
          }
        }
      })}
      {range.length ? <button
        disabled={page === range.slice(-1)[0]}
        className={`${styles.button} ${page === range.slice(-1)[0] && styles.noClick}`}
        onClick={() => nextPage()}>
        <i className="fas fa-chevron-right"></i>
      </button> : null}
    </div >
  );
};

export default Pagination;